'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var TabList = function TabList(props) {
    var children = props.children,
        className = props.className,
        stretched = props.stretched,
        attributes = __rest(props, ["children", "className", "stretched"]);

    return _react2.default.createElement("ul", Object.assign({}, attributes, { className: (0, _classnames2.default)(className, stretched ? 'luna-tabs__list--stretch' : ''), role: "tablist" }), children);
};
TabList.defaultProps = {
    className: 'luna-tabs__list'
};
TabList.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
    stretched: _propTypes2.default.bool.isRequired
};
exports.default = TabList;
//# sourceMappingURL=TabList.js.map